import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectTreeCategoriesList} from 'modules/categories/selectors';

export const useCategoriesTree = () => {
    return useAppSelector(selectTreeCategoriesList);
};
